import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import {Autocomplete} from "@material-ui/lab";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {ajustesResources, eliminarConteoResources} from "../endpoints";

class DialogEliminarConteo extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            datos_conteo : props.conteo,
            motivos:[],
            motivo: ""
        }
    }

    getMotivos = () =>{
        ajustesResources.getMotivosAjustes().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            this.setState({motivos:result})
        }).catch(error=> {
            console.log(error)
        });
    }

    eliminarConteo = () =>{
        this.setState({openSnack:false, severity: null, message:null})
        if(this.props.tipo === "desagrupado"){
            eliminarConteoResources.eliminarConteoDesagrupado(this.state.datos_conteo.id,this.state.motivo.id).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                this.setState({motivo:""})
                if(result.message){
                    this.props.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                console.log(error)
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
            });
        }
        else{
            eliminarConteoResources.eliminarConteoAgrupado(this.props.tag,this.state.datos_conteo.codigo,this.state.datos_conteo.id_codigo_tipo, this.state.motivo.id).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                this.setState({motivo:""})
                if(result.message){
                    this.props.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                console.log(error)
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
            });
        }
    }

    getEventType = (event) =>{
        if(event.keyCode === 13){
            if(this.state.motivo !== ""){
                this.eliminarConteo()
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.getEventType, false);
    }

    componentDidMount() {
        document.addEventListener('keyup', this.getEventType, false);
        this.getMotivos()
    }

    render() {
        return(
            <Dialog
                open={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Eliminar conteo</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} alignItems="flex-end">
                        <Grid item xs={12}>
                            Material: {this.state.datos_conteo.articulo}
                        </Grid>
                        <Grid item xs={12}>
                            Descripción material: {this.state.datos_conteo.descripcion}
                        </Grid>
                        <Grid item xs={12}>
                            Cantidad actual: {this.state.datos_conteo.cantidad}
                        </Grid>
                        <Grid item xs={12}>
                            Seleccione un motivo:
                            <Autocomplete
                                id="size-small-standard"
                                onChange={(event, newValue) => {
                                    if(newValue === null) {
                                        this.setState({motivo: ""})
                                    }
                                    else{
                                        this.setState({motivo: newValue})
                                    }
                                }}
                                size="small"
                                options={this.state.motivos}
                                noOptionsText={"No hay opciones"}
                                getOptionLabel={(option) => option.descripcion|| ""}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" label="Motivo" placeholder="Disponibles" />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            Está seguro que desea eliminar el conteo?
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                    <Button variant="contained" color="primary" onClick={this.eliminarConteo} disabled={this.state.motivo === ""}>
                        Eliminar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default DialogEliminarConteo